import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Avatar,
  Typography
} from "@mui/material";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import CompanyVeiwController from "../../redux/actions/companyApiActions";
import { FadeLoader } from "react-spinners";
import { IMAGE_URL } from "../../services/api";
function CompanyFormModal({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const { addCompany, updateCompany } = CompanyVeiwController();
  const { isLoding } = useSelector((state) => state.company);

  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    company_name: "",
    email: "",
    location: "",
    employee_strength: "",
    description: "",
    company_logo: ""
  });

  useEffect(() => {
    if (show) {
      const base = {
        company_name: initialData?.company_name || "",
        email: initialData?.email || "",
        location: initialData?.location || "",
        employee_strength: initialData?.employee_strength || "",
        description: initialData?.description || "",
        company_logo: ""
      };

      setInitialValues(base);

      if (initialData?.company_logo) {
        const fullUrl = `${IMAGE_URL}${initialData.company_logo}`;
        convertImageUrlToBase64(fullUrl).then((base64) => {
          setInitialValues((prev) => ({
            ...prev,
            company_logo: base64
          }));
        });
      }
    }
  }, [show, initialData]);

  const convertImageUrlToBase64 = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const handleImageToBase64 = (file, setFieldValue) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setFieldValue("company_logo", reader.result);
    };
    if (file) reader.readAsDataURL(file);
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = (values, { resetForm }) => {
    setLoading(true);
    const action = isEdit
      ? updateCompany(initialData.id, values)
      : addCompany(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEdit ? "Edit Company" : "Create Company"}</DialogTitle>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, handleChange }) => (
          <Form>
            <DialogContent dividers>
              <Grid container spacing={2}>
                {/* Row 1 */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Company Name"
                    name="company_name"
                    value={values.company_name}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    name="email"
                    type="email"
                    value={values.email}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>

                {/* Row 2 */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Location"
                    name="location"
                    value={values.location}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Employee Strength"
                    name="employee_strength"
                    type="number"
                    value={values.employee_strength}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>

                {/* Row 3 - Full width */}
                <Grid item xs={12}>
                  <TextField
                    label="Description"
                    name="description"
                    value={values.description}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={3}
                  />
                </Grid>

                {/* Row 4 - Logo preview (if exists) */}
                {values.company_logo && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2">Current Logo</Typography>
                    <Avatar
                      src={values.company_logo}
                      alt="Company Logo"
                      variant="rounded"
                      sx={{ width: 100, height: 100, mb: 1 }}
                    />
                  </Grid>
                )}

                {/* Row 5 - File upload */}
                <Grid item xs={12}>
                  <Button variant="outlined" component="label" fullWidth>
                    Upload Logo
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={(e) =>
                        handleImageToBase64(e.target.files[0], setFieldValue)
                      }
                    />
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button type="submit" variant="contained" color="primary">
                {isEdit ? "Update" : "Create"}
              </Button>

               {isLoding && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.6)",
                    zIndex: 9999,
                  }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(45deg,rgb(65, 63, 63),rgb(238, 231, 238))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    <FadeLoader loading={true} size={150} aria-label="Loading Spinner" />
                  </div>
                </div>
              )}
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default CompanyFormModal;
